import { Alert, Button } from "@growtherapy/sprout-ui";
import {
  SEPARATE_ACCOUNT_CALLOUT_HEADING,
  SEPARATE_ACCOUNT_CALLOUT_MESSAGE,
  SEPARATE_ACCOUNT_CONTACT_SUPPORT_BUTTON_LABEL,
} from "../lang";
import { useContactUs } from "../../../useContactUs";

export function SeparateAccountCallout() {
  const { pageUrl } = useContactUs();

  return (
    <Alert
      use="info"
      icon={null}
      heading={SEPARATE_ACCOUNT_CALLOUT_HEADING}
      actions={
        <Button
          className="flex-shrink-0"
          onClick={() => {
            window.open(pageUrl, "_blank");
          }}
        >
          {SEPARATE_ACCOUNT_CONTACT_SUPPORT_BUTTON_LABEL}
        </Button>
      }
    >
      {SEPARATE_ACCOUNT_CALLOUT_MESSAGE}
    </Alert>
  );
}
